import React from "react";
import { Link, useParams } from "react-router-dom";
import "../styles/rpmPatientsList.css";
import RpmListHeader from "../components/RpmListHeader";

const title = (
  <div className="flex flex-row gap-2 items-center">
    <span>Patient</span>
  </div>
);

/**
 * rpm-dashboard uses PatientDashboard at /landing/rpm_list/:id.
 * energyband only mirrors the list route; this stub keeps in-app links working.
 */
const OwnerLanding2Patient = () => {
  const { id } = useParams();

  return (
    <div className="min-h-screen bg-[#F5F5F7]">
      <RpmListHeader pageTitle={title} />
      <div className="px-4 py-6 max-w-lg mx-auto">
        <Link
          to="/owner-landing2"
          className="text-[#4264D0] font-bold text-sm no-underline"
        >
          ← Back to patients
        </Link>
        <p className="mt-4 text-[#18357A] font-bold">Patient No: {id}</p>
        <p className="text-[#5B6680] text-sm mt-2">
          The full patient dashboard from rpm-dashboard is not bundled here;
          open the rpm-dashboard app for that view.
        </p>
      </div>
    </div>
  );
};

export default OwnerLanding2Patient;
